// Viewer-facing display states, derived per surface — not persisted statuses. 'change-actioned'
// is 'change-required' once the assignee has edited their unsubmitted answer: same copy and icon,
// the grey colour alone signals "done".
export type AmendmentState = 'awaiting-change' | 'change-required' | 'change-actioned' | 'changed'

// Theme-v2 chip colours and the question line's variant vocabulary are the same tokens, so one map drives both.
export const AMENDMENT_STATE_COLOR: Record<AmendmentState, 'info' | 'warning' | 'neutral'> = {
  'awaiting-change': 'info',
  'change-required': 'warning',
  'change-actioned': 'neutral',
  changed: 'warning',
}
